// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-auth-dialog {
  max-width: 420px;
  margin: 1.25rem auto;
}

.checkout-auth-dialog .modal-content {
  background: #e6eee2;
  border: 0;
  border-radius: 22px;
  box-shadow: 0 24px 60px rgba(17, 17, 17, 0.22);
  overflow: hidden;
}

.checkout-auth-dialog .modal-body {
  padding: 0;
  overflow: hidden;
}

.checkout-auth {
  padding: 16px 20px 18px;
  overflow: hidden;
}

.checkout-auth__logo {
  display: block;
  height: 28px;
  width: auto;
  object-fit: contain;
}

.checkout-auth__input {
  height: 42px;
  border: 0;
  border-radius: 12px !important;
  font-size: 14px;
  box-shadow: 0 1px 2px rgba(17, 17, 17, 0.04);
}

.checkout-auth__input:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(201, 51, 18, 0.14);
}

.checkout-auth__or {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 10px;
  margin: 12px 0;
  color: #6f776c;
  font-size: 12px;
}

.checkout-auth__or::before,
.checkout-auth__or::after {
  content: "";
  height: 1px;
  background: rgba(17, 17, 17, 0.12);
}

.checkout-auth__google {
  height: 42px;
  border: 0;
  border-radius: 12px;
  background: #fff;
  color: #1f1f1f;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(17, 17, 17, 0.05);
}

.checkout-auth__google:hover,
.checkout-auth__google:focus {
  background: #fff;
  color: #1f1f1f;
  opacity: 1 !important;
}

.checkout-auth__copy {
  min-width: 0;
}

.checkout-auth__check .form-check-input {
  width: 16px;
  height: 16px;
  margin-top: 3px;
  flex-shrink: 0;
}

.checkout-auth__check .form-check-input:checked {
  background-color: #0e0e0e;
  border-color: #0e0e0e;
}

.checkout-auth__thumb {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 8px;
  background: #d7dfd2;
  flex-shrink: 0;
}

@media (max-width: 575.98px) {
  .checkout-auth-dialog {
    max-width: calc(100% - 24px);
    margin: 12px auto;
  }

  .checkout-auth {
    padding: 16px 16px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modals/CheckoutAuthModal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".checkout-auth-dialog {\n  max-width: 420px;\n  margin: 1.25rem auto;\n}\n\n.checkout-auth-dialog .modal-content {\n  background: #e6eee2;\n  border: 0;\n  border-radius: 22px;\n  box-shadow: 0 24px 60px rgba(17, 17, 17, 0.22);\n  overflow: hidden;\n}\n\n.checkout-auth-dialog .modal-body {\n  padding: 0;\n  overflow: hidden;\n}\n\n.checkout-auth {\n  padding: 16px 20px 18px;\n  overflow: hidden;\n}\n\n.checkout-auth__logo {\n  display: block;\n  height: 28px;\n  width: auto;\n  object-fit: contain;\n}\n\n.checkout-auth__input {\n  height: 42px;\n  border: 0;\n  border-radius: 12px !important;\n  font-size: 14px;\n  box-shadow: 0 1px 2px rgba(17, 17, 17, 0.04);\n}\n\n.checkout-auth__input:focus {\n  border-color: transparent;\n  box-shadow: 0 0 0 3px rgba(201, 51, 18, 0.14);\n}\n\n.checkout-auth__or {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 10px;\n  margin: 12px 0;\n  color: #6f776c;\n  font-size: 12px;\n}\n\n.checkout-auth__or::before,\n.checkout-auth__or::after {\n  content: \"\";\n  height: 1px;\n  background: rgba(17, 17, 17, 0.12);\n}\n\n.checkout-auth__google {\n  height: 42px;\n  border: 0;\n  border-radius: 12px;\n  background: #fff;\n  color: #1f1f1f;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(17, 17, 17, 0.05);\n}\n\n.checkout-auth__google:hover,\n.checkout-auth__google:focus {\n  background: #fff;\n  color: #1f1f1f;\n  opacity: 1 !important;\n}\n\n.checkout-auth__copy {\n  min-width: 0;\n}\n\n.checkout-auth__check .form-check-input {\n  width: 16px;\n  height: 16px;\n  margin-top: 3px;\n  flex-shrink: 0;\n}\n\n.checkout-auth__check .form-check-input:checked {\n  background-color: #0e0e0e;\n  border-color: #0e0e0e;\n}\n\n.checkout-auth__thumb {\n  width: 36px;\n  height: 36px;\n  object-fit: cover;\n  border-radius: 8px;\n  background: #d7dfd2;\n  flex-shrink: 0;\n}\n\n@media (max-width: 575.98px) {\n  .checkout-auth-dialog {\n    max-width: calc(100% - 24px);\n    margin: 12px auto;\n  }\n\n  .checkout-auth {\n    padding: 16px 16px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
